<template>
  <v-layout row wrap justify-center class="mini">
    <v-toolbar
       
      card
      dense
      height="32"
      
    >
      <v-icon small pa-0  >credit_card</v-icon>
      <v-toolbar-title style="margin-left: 8px;">
        <h6>Expenses</h6>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        small
        depressed
        round
        fab
        flat
        
        
        class="mb-2"
        v-show="!allPanelsClosed()"
        @click="closePanels"
      >
        <v-icon>view_headline</v-icon>
      </v-btn>
      <v-btn
        small
        depressed
        round
        fab
        flat
        
        class="mb-2"
        v-show="allPanelsClosed()"
        @click="openPanels"
      >
        <v-icon>view_stream</v-icon>
      </v-btn>
    </v-toolbar>

    <v-layout>
      <v-expansion-panel class="mini" expand v-model="panel">
        <v-expansion-panel-content
          ripple
          v-for="score_costs_lines of sortedScoreCosts"
          :key="score_costs_lines[0].name"
        >
          <div slot="header">
            <v-layout row>
              <v-flex>
                {{ score_costs_lines[0] && score_costs_lines[0].name }}
              </v-flex>
              <v-flex>
                <v-layout justify-end mx-4>
                  {{ getLineCostWithScoreCurrency(score_costs_lines) }}
                </v-layout>
              </v-flex>
            </v-layout>
          </div>

          <v-card flat>
            <fixedPriceScoreCost
              v-if="score_costs_lines[0].calculation == 'fixed_price'"
              :scoreCosts="score_costs_lines"
              :previsional="previsional"
              :editable="editable"
            />

            <quantityUnitPriceScoreCost
              v-if="
                score_costs_lines[0].calculation == 'quantity_times_unit_price'
              "
              :scoreCosts="score_costs_lines"
              :previsional="previsional"
              :editable="editable"
            />

            <freightQuantityUnitPriceScoreCost
              v-if="
                score_costs_lines[0].calculation ==
                'freight_quantity_times_unit_price'
              "
              :scoreCosts="score_costs_lines"
              :previsional="previsional"
              :editable="editable"
            />

            <netWeightTimesUnitPriceScoreCost
              v-if="
                score_costs_lines[0].calculation ==
                'net_weight_times_unit_price'
              "
              :scoreCosts="score_costs_lines"
              :previsional="previsional"
              :editable="editable"
            />

            <percentageCustomerSellingPriceScoreCost
              v-if="
                score_costs_lines[0].calculation ==
                'percentage_times_customer_selling_price'
              "
              :scoreCosts="score_costs_lines"
              :previsional="previsional"
              :editable="editable"
            />
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-layout>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import quantityUnitPriceScoreCost from "./quantityUnitPriceScoreCost";
import fixedPriceScoreCost from "./fixedPriceScoreCost";
import netWeightTimesUnitPriceScoreCost from "./netWeightTimesUnitPriceScoreCost";
import freightQuantityUnitPriceScoreCost from "./freightQuantityUnitPriceScoreCost";
import percentageCustomerSellingPriceScoreCost from "./percentageCustomerSellingPriceScoreCost";
import scoreCost from "../../mixins/scoreCost";

export default {
  name: "scoreCosts",
  mixins: [scoreCost],
  props: {
    previsional: {
      type: Boolean,
      required: true,
    },
    editable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: {
    quantityUnitPriceScoreCost,
    fixedPriceScoreCost,
    netWeightTimesUnitPriceScoreCost,
    freightQuantityUnitPriceScoreCost,
    percentageCustomerSellingPriceScoreCost,
  },
  data() {
    return {
      panel: new Array(50).fill(false),
    };
  },
  computed: {
    ...mapGetters("commonStore", ["scoreCostOrder"]),
    ...mapGetters("contractStore", [
      "previsional_score_costs",
      "score_costs",
      "contract",
    ]),
    scoreCosts() {
      if (this.previsional) return this.previsional_score_costs;
      return this.score_costs;
    },
    sortedScoreCosts() {
      var self = this;
      var ret = {};
      function compare(a, b) {
        let a_order = self.scoreCostOrder(a);
        let b_order = self.scoreCostOrder(b);
        if (a_order > b_order) return 1;
        return -1;
      }

      Object.keys(this.scoreCosts)
        .sort(compare)
        .forEach(function (key) {
          ret[key] = self.scoreCosts[key];
        });
      return ret;
    },
  },
  methods: {
    closePanels() {
      this.panel = [];
    },
    openPanels() {
      this.panel = new Array(50).fill(true);
    },
    allPanelsClosed() {
      for (var i = 0; i < this.panel.length; i++) {
        if (this.panel[i]) return false;
      }
      return true;
    },
  },
};
</script>
<style lang="stylus">
.mini {
  .v-expansion-panel__header {
    min-height: 0;
    padding: 3px 24px !important;
  }

  tbody {
    tr {
      height: 60px !important;

      td {
        height: 20px !important;
      }
    }
  }
}

.borderedTitle {
  border-bottom: 2px solid #eaeaea;
}
</style>

<style scoped>
@media only screen and (min-width: 1524px) {
  .largehead {
    display: inline-block;
  }
  .smallhead {
    display: none;
  }
}

@media only screen and (max-width: 1523px) {
  .largehead {
    display: none;
  }
  .smallhead {
    display: inline-block;
  }
}
</style>
